import React, { useState } from "react";

// One sidebar tab holding several views: the header, a switch under it, then the
// selected view's body. Each view gets the tab's props (user, onForbidden).
function ViewSwitchTab({ kicker, title, label, views, ...props }) {
  const [view, setView] = useState(views[0].key);
  const View = views.find((option) => option.key === view).component;

  return (
    <div>
      <p className="kicker">{kicker}</p>
      <h2 className="admin-title admin-title--left">{title}</h2>
      <div className="admin-linked-filter admin-view-switch" role="tablist" aria-label={label}>
        {views.map((option) => (
          <button
            key={option.key}
            type="button"
            role="tab"
            aria-selected={view === option.key}
            className={`admin-tab admin-linked-filter-btn ${view === option.key ? "admin-tab-active" : ""}`}
            onClick={() => setView(option.key)}
          >
            {option.label}
          </button>
        ))}
      </div>
      <View {...props} />
    </div>
  );
}

export default ViewSwitchTab;
